<template>
	<component
		:is="componentType"
		:to="to"
		:href="href"
		:target="target"
		class="flex items-center w-full gap-2 px-4 py-2 text-base font-normal text-left transition-colors duration-150 cursor-pointer text-neutral-700 hover:bg-neutral-100 hover:text-neutral-900 whitespace-nowrap dropdown-item"
		@click="handleClick"
	>
		<Icon
			v-if="icon"
			:icon="[iconPrefix, icon]"
			:size="iconSize"
			class="flex-shrink-0"
		>
		</Icon>
		<span class="flex-1">
			<slot></slot>
		</span>
	</component>
</template>

<script>
import Icon from '~/components/ui/common/Icon'

export default {
	name: 'DropdownItem',
	components: {
		Icon
	},
	props: {
		icon: {
			type: String,
			default: null
		},
		iconPrefix: {
			type: String,
			default: 'far'
		},
		iconSize: {
			type: String,
			default: 'sm'
		},
		to: {
			type: [String, Object],
			default: null
		},
		href: {
			type: String,
			default: null
		},
		target: {
			type: String,
			default: null
		}
	},
	computed: {
		componentType() {
			if (this.to) {
				return 'router-link'
			} else if (this.href) {
				return 'a'
			} else {
				return 'div'
			}
		}
	},
	methods: {
		handleClick(event) {
			this.$emit('click', event)
		}
	}
}
</script>
